/**
 * @author PoornaChandu
 * @description Template to download files based on module code 
 */
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { Radio, Button, Select, Form, Upload, message } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { API_MODULES, IPAddress } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import translation from '../Utils/translation';
import { handleDownload } from "../APICalls";



const { Option } = Select;

const MasterTemplate = (props) => {
  const [selectedType, setSelectedType] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [moduleFile, setModuleFile] = useState("");
  const [moduleList, setModuleList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  useEffect(() => {
    if ( selectedType === 'download'){
    getList();
    }
  }, [selectedType]);

  useEffect(() => {
    if (selectedModule !== '') {
      downloadFiles();
    }
    setModuleFile(moduleFile);
  }, [selectedModule, moduleFile]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [translationCache]);

  const downloadFiles = async () => {

    let fileDownloadName = await handleDownload(selectedModule);
    setModuleFile(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  const getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `${API_MODULES.ModulesGet}?Status=Active&SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {

        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setModuleList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div style={{
      marginLeft: 300,
      marginTop: '200px',
      border: '2px solid grey',
      borderRadius: 15,
      boxShadow: '5px 5px 10px rgba(73, 63, 63, 0.5)',
      width: '60%'
    }}
    >
      <Radio.Group
        style={{
          display: 'flex',
          flexDirection: 'row',
          color: 'white ',
          marginLeft: '300px',
          marginTop: '20px',
          marginBottom: '20px'
        }}
        value={selectedType}
        buttonStyle="solid"
        onChange={(e) => {
          setSelectedType(e.target.value);
        }}
      >
        <Radio style={{ color: 'white', marginRight: '300px' }} value="upload">
          Upload
        </Radio>
        <Radio style={{ color: 'white' }} value="download"
        >
          Download
        </Radio>
      </Radio.Group>
      <div>
        {selectedType === 'upload' ? (
          <Upload
            multiple={false}
            style={{ marginLeft: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/mastertemplate/upload?SiteId=${siteId}`}
            headers={{
              Authorization: Authorization
            }}
            showUploadList={false}
          >
            <Button
              type='primary'
              style={{ marginLeft: '300px', marginTop: 10, marginBottom: 40 }}
            >
              Upload <UploadOutlined />
            </Button>
          </Upload>
        ) : selectedType === 'download' ? (
          <Form
            name="ModuleFileUpload"
            layout="horizontal"
            labelCol={{ flex: '250px' }}
            labelAlign="right"
            labelWrap
          >
            <div style={{ marginTop: 40 }}>
              <Form.Item
                style={{ width: '100%', flex: '50%' }}
                value=""
                label={translation(translationCache, 'Select Module')}
                name="ModuleSelected"
              >
                <Select
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, 'Select Module')}
                  onChange={(e) => setSelectedModule(e)}
                >
                  {moduleList &&
                    Array.isArray(moduleList) &&
                    moduleList.map((Module, index) => {
                      return (
                        <Option key={index} value={Module.AliasCode}>
                          {Module.Code}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '40px' }}>
                {/* <Form.Item>
                  <Button
                    type='primary'
                    style={{ marginLeft: '250px' }}
                  >
                    Submit
                  </Button>
                </Form.Item> */}
                <Form.Item>
                  {/* <Upload> */}
                  <Button
                    type='primary'
                    style={{ marginLeft: '260px' }}
                  >
                    <a href={`${IPAddress.LOCAL}/api/downloads/${moduleFile}`}>
                      Download <DownloadOutlined />
                    </a>
                  </Button>
                  {/* </Upload> */}
                </Form.Item>
              </div>
            </div>
          </Form>
        ) : null}
      </div>
    </div>

  );
};

export default MasterTemplate;
